import ChantDocument from "./ChantDocument";

const defaultFiles = {
  "Ad te levavi (EN-GR)": `title: First Sunday of Advent;
subtitle: <i>Mass</i>;
supertitle: <sc>advent season</sc>;
text-right: <i>Cf. Ps 25 (24): 1-3</i>;
annotation: VIII;
%%
(c4) AD[To you, I lift up](gd~) te(f) le(gh)vá(hv_)vi[/](g) *(,)
á[my soul;](gjjv_)ni(h)mam(gh>_) me(fg)am:[/](ghgg_f_) (;)
De[O my God,](hv_)us(jv_jv_) me(js!js/k[cs:c]j)us[/](jo!kv_) (,)
in[in you](fg~) te[/](gv_) con[I have trusted;](f)fí(FH/ji)do,[/](ih__) (,)
non[let me not be put to shame.](js!js!js) e(hg)ru(ghfg_)bés(ghg___)cam:[/](gv_) (:)
ne[Nor](jv_)que[/](i_js!js!js/hih___) (\`)()
ir[let them exult over me,](h)rí(jkj)de(i[cs:c]h)ant(js!js!js>) me[/](g )
i[my enemies;](g)ni(g)mí(g!h!iwj)ci(jh) me(h_[cs:t]f_)i:[/](f) (:)
é[and let those](fh)te(hg)nim(g) u(g)ni(g)vér(gihi)si(g) [/](,)()
qui[who hope in you](g) te(g) ex(hji)péc(i/jkj)tant,[/](-hi_h_) (;)
non[not be put to shame.](gh~) con(hv_)fun(hfhg)dén(ghg___)tur.[/](g) (::)`,

  "To you I lift (EN-LCG)": `title: First Sunday of Advent;
subtitle: <i>Mass</i>;
supertitle: <sc>advent season</sc>;
text-left: <i>Ad te levavi</i>;
text-right: <i>Cf. Ps 25 (24): 1-3</i>;
annotation: VIII;
%%
(c4) TO(g) you,(fd) I(f) lift(h) up(g) my(f) soul,(g) (,) O(h) my(f) {Go}d.(ghg___) *(:) In(fg) you,(h_ ) I(g) have(h) trust(jkj )ed;(j) (;) let(i) me(j) not(k) be(i) put(ji) to(g) shame.(hg__) (:) Nor(jh) let(i) my(k) en(jvjv )e(i )mies(g) (,) ex(g )ult(hg) o(f )ver(h) me;(g) (;) and(g) let(hi) none(ji) who(h) hope(iviv) in(h) you(g) (,) be(g) put(fd) to(f) {sham}e.(ghg___) (::)`,

  "To you I lift (EN-SEP2)": `title: First Sunday of Advent;
subtitle: <i>Mass</i>;
supertitle: <sc>advent season</sc>;
text-left: <i>Ad te levavi</i>;
text-right: <i>Cf. Ps 25 (24): 1-3</i>;
annotation: VIII;
%%
(c3) TO(e) you,(eh) I(h) lift(h) up(h) my(h) soul,(h) (,) O(g) my(f) {Go}d.(hih___) *(;) In(gh) you,(i_) I(i) have(h) trust(ij)ed;(i) (,) let(i) me(i) not(h) be(i) put(jvjv) to(i) shame.(hvGE) (:) Nor(d) let(f) my(h) en(h)e(h)mies(h) ex(h)ult(hf) o(g)ver(h) me;(iji) (;) and(i) let(ji) none(hih) who(h) hope(hg) in(f) you(h) (,) be(f) put(gf) to(g) shame.(e_f_e_) (::)`
};

for (let [filename, gabc] of Object.entries(defaultFiles)) {
  localStorage["file/" + filename] = JSON.stringify({
    ...ChantDocument.getDefaultChantDocument(),
    name: filename,
    gabc
  });
}

const DefaultFileSystem = {
  fileList: Object.keys(defaultFiles).map(name => ({
    path: "/",
    name,
    lastAccessed: 0
  })),
  getFileList: currentList => {
    if (!currentList || !(currentList instanceof Array))
      return DefaultFileSystem.fileList;
    for (let file of DefaultFileSystem.fileList) {
      if (
        currentList.some(
          currentFile =>
            currentFile.path === file.path && currentFile.name === file.name
        )
      )
        continue;
      currentList.push(file);
    }
    return currentList;
  },
  copyFile: (file, filename) => {
    localStorage["file" + file.path + filename] =
      localStorage["file" + file.path + file.name];
  },
  renameFile: (file, filename) => {
    localStorage["file" + file.path + filename] =
      localStorage["file" + file.path + file.name];
    delete localStorage["file" + file.path + file.name];
    file.name = filename;
  },
  newFile: file => {
    localStorage["file" + file.path + file.name] = JSON.stringify(
      ChantDocument.getDefaultChantDocument()
    );
  }
};

export default DefaultFileSystem;
